import React from 'react'
import { MoonLoader } from 'react-spinners'
import styled from 'styled-components'
import { Colors } from 'advenio-components'

const Spinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`

const LoadingSpinner = () => <Spinner><MoonLoader color={Colors.blue500} size={25} /></Spinner>

export default LoadingSpinner



// WEBPACK FOOTER //
// ./src/shared/LoadingSpinner.jsx